<template>
  <div class="kyc_body">
      <div class="kyc_hrader">
          <div class="kyc_h1">{{$t('main.text66')}}</div>
          <div class="kyc_h2"><el-button @click="upload_4_all" :disabled="dab_btn">{{$t('main.text67')}}</el-button></div>
      </div>
      <div class="kyc_main">

          <div class="r_box">
            <div class="r_box1">
              <div>
                <div class="r_box3_ok" v-if="one_status_icon==1">{{$t('main.text68')}}</div>
                <div class="r_box3" v-else>{{$t('main.text69')}}</div>
                <div class="r_box4">{{$t('main.text69_y')}}</div>
                <div class="r_box5">{{$t('main.text70')}}</div>
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="$router.push('/kyc_step/kyc_step_one')">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r_box">
            <div class="r_box1">
              <div>
                <div class="r_box3_ok" v-if="two_status_icon==1">{{$t('main.text68')}}</div>
                <div class="r_box3" v-else>{{$t('main.text69')}}</div>
                <div class="r_box4">{{$t('main.text22')}}</div>
                <div class="r_box5">{{$t('main.text256')}}</div>
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="$router.push('/kyc_step/kyc_step_two')">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r_box">
            <div class="r_box1">
              <div>
                <div class="r_box3_ok" v-if="three_status_icon==1">{{$t('main.text68')}}</div>
                <div class="r_box3" v-else>{{$t('main.text69')}}</div>
                <div class="r_box4">{{$t('main.text23')}}</div>
                <div class="r_box5">{{$t('main.text256')}}</div>
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="$router.push('/kyc_step/kyc_step_three')">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r_box">
            <div class="r_box1">
              <div>
                <div class="r_box3_ok" v-if="four_status_icon==1">{{$t('main.text68')}}</div>
                <div class="r_box3" v-else>{{$t('main.text69')}}</div>
                <div class="r_box4">{{$t('main.text24')}}</div>
                <div class="r_box5">{{$t('main.text256')}}</div>
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="$router.push('/kyc_step/kyc_step_four')">{{$t('main.text71')}}</span>
            </div>
          </div>
          
      </div>

      <!-- 第几步没有填写完成 -->
      <el-dialog
        :visible.sync="info_ji_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text72')}}
        </div>
        <div class="log_out3">
          <span v-if="one_status_icon==0">{{$t('main.text73')}}</span>
          <span v-else-if="two_status_icon==0">{{$t('main.text74')}}</span>
          <span v-else-if="three_status_icon==0">{{$t('main.text75')}}</span>
          <span v-else-if="four_status_icon==0">{{$t('main.text76')}}</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button class="cancel_btn">Submit now</el-button> -->
            <el-button type="primary" class="confirm_btn" @click="info_ji_dlg = false">{{$t('main.text11')}}</el-button>
        </span>
      </el-dialog>

      <!-- 全部填写完成 -->
      <el-dialog
        :visible.sync="info_4_all_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img style="width:80px;" src="../../assets/img/info_4_all.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text77')}}
        </div>
        <div class="log_out3">
          {{$t('main.text78')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button class="cancel_btn">Submit now</el-button> -->
            <el-button type="primary" class="confirm_btn" @click="info_4_all_dlg=false">{{$t('main.text11')}}</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
import {getKycInfo,kyc_all_submit} from '@/api/api';

export default {
    data() {
        return {
            info_ji_dlg:false,
            one_status_icon:'',//状态 0信息不完整 1信息完整,
            two_status_icon:'',//状态 0信息不完整 1信息完整,
            three_status_icon:'',//状态 0信息不完整 1信息完整,
            four_status_icon:'',//状态 0信息不完整 1信息完整,
            info_4_all_dlg:false,
            dab_btn:false,

        }
    },
    mounted() {
      this.get_kyc();
    },
    methods: {
      get_kyc(){
        getKycInfo().then(res=>{
          if(res.data.code==200){
            this.one_status_icon=res.data.data.corporate_fi_status;
            this.two_status_icon=res.data.data.company_status;
            this.three_status_icon=res.data.data.shareholder_status;
            this.four_status_icon=res.data.data.trading_status;

            // "status": 状态 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
            if(res.data.data.status==2||res.data.data.status==3||res.data.data.status==4||res.data.data.status==5){
              this.dab_btn=true;
            }else{
              this.dab_btn=false;
            }
            
          }else{
            
            this.message.ismessage('error',res.data.msg);
          }
        })
      },
      upload_4_all(){
        
        if(this.one_status_icon==1&&
            this.two_status_icon==1&&
            this.three_status_icon==1&&
            this.four_status_icon==1){
              this.got_it();
            }else{
              this.info_ji_dlg=true;
            }
      },
      got_it(){
        kyc_all_submit().then(res=>{
          if(res.data.code==409){
            
            this.message.ismessage('success',this.$t('main.text79'));
            this.info_4_all_dlg=true;
          }else{
            
            this.message.ismessage('error',res.data.msg);
          }
        })
      }


    },
}
</script>

<style scoped>
.kyc_body{
    color: #FFFFFF;
}
.kyc_hrader{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.kyc_h1{
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
}
.kyc_h2 button{
    width: 163px;
    height: 38px;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    border-color: #F1C788;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    margin: 0px 20px;

    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #04182A;
}
.kyc_main{
    padding-top: 20px;
    box-sizing: border-box;
    /* margin-bottom: 80px; */
}
.r_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 35px;
  /* cursor: pointer; */
}
.kyc_main .r_box:last-child{
  margin-bottom: 0;
}

.r_box1 {
  display: flex;
  align-items: center;
  width: 50%;
}
.r_box3 {
  display: inline-block;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;
  box-sizing: border-box;
  box-sizing: border-box;
  padding: 3px 9px;
  opacity: 0.6;
  border: 2px solid #465D78;
  border-radius: 4px;
  margin-bottom: 10px;
}
.r_box3_ok {
  display: inline-block;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #12BA9C;
  box-sizing: border-box;
  box-sizing: border-box;
  padding: 3px 9px;
  /* opacity: 0.6; */
  border: 2px solid #12BA9C;
  border-radius: 4px;
  margin-bottom: 10px;
}

.r_box4 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  color: #ffffff;
  /* margin-left: 20px; */
  margin-bottom: 4px;
}
.r_box5 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  margin-top: 4px;
  color: #ffffff;
  /* margin-left: 20px; */
  opacity: 0.6;
}
.r_box6 {
  font-size: 15px;
  color: #deb981;
  cursor: pointer;
  margin-right: 20px;
}

/* 滚动条 */
/* .kyc_body {
  overflow: auto;
  height: calc(100vh - 80px);
}
.kyc_body::-webkit-scrollbar {
  width: 5px;
}
.kyc_body::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #687eec;
} */
/* --over-- */
/* 退出弹框 */
.log_out1 img{
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  text-align: center;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
}
.cancel_btn{
  color: #F1C788;
  border-color: #F1C788;
  background: transparent;
}
.confirm_btn{
  width: 163px;
  height: 38px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182A;
  /* margin-left: 20px; */
  margin-bottom: 15px;
}
.do_it_later{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #DEB981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}

/* --over-- */
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .kyc_hrader{
    display: block;
  }
  .kyc_h2 button{
    margin: 10px 0;
  }
  .r_box{
    display: block;
  }
  .r_box1{
    width: 100%;
  }

}

</style>
